<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: SourceHanSansCN-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
/*html, body {*/
/*  position: relative;*/
/*  height: 100%;*/
/*}*/
body {
  /*background: #eee;*/
  font-family: sans-serif;
  font-size: 14px;
  color: #000;
  margin: 0;
  padding: 0;
}
ul{
  /*list-style: none;*/
  padding: 0;
  margin: 0;
}
.swiper-slide{
  cursor: pointer;
}
.btn-default{
  background-color: transparent !important;
  color: #ffffff !important;
  border-radius: 0 !important;
  border-color: #FF6060 !important;
}
.btn-default:hover{
  background-color: transparent !important;
  color: #ffffff !important;
  border-color: #FF6060 !important;
}
.btn-default:focus{
  background-color: transparent !important;
  color: #fff !important;
  border-radius: 0 !important;
  border-color:#FF6060 !important;
}
.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn){
  width: 245px !important;
}
.bootstrap-select>.dropdown-toggle.bs-placeholder, .bootstrap-select>.dropdown-toggle.bs-placeholder:active, .bootstrap-select>.dropdown-toggle.bs-placeholder:focus, .bootstrap-select>.dropdown-toggle.bs-placeholder:hover{
  color: #fff !important;
  background-color: transparent !important;
  border-color: #FF6060 !important;
  width: 245px !important;
}
.btn-default.active.focus, .btn-default.active:focus, .btn-default.active:hover, .btn-default:active.focus, .btn-default:active:focus, .btn-default:active:hover, .open>.dropdown-toggle.btn-default.focus, .open>.dropdown-toggle.btn-default:focus, .open>.dropdown-toggle.btn-default:hover{
  color: #fff !important;
  background-color: transparent !important;
  border-color: #FF6060 !important;
}
.btn-default.active, .btn-default:active, .open>.dropdown-toggle.btn-default{
  background-color: transparent !important;
  color: #ffffff !important;
  border-color: #FF6060 !important;
}
.bootstrap-select>select{
  background-color: transparent !important;
  color: #fff !important;
}
.swiper-slide {
  text-align: center !important;
  font-size: 18px !important;
  /*background: #fff;*/
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex !important;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.swiper-pagination{
  text-align: right !important;
}
.swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction{
  bottom: -3px !important;
}
.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{
  margin: 0 1px !important;
}
.swiper-pagination-bullet {
  width: 22px !important;
  height: 22px !important;
  text-align: center !important;
  line-height: 22px !important;
  font-size: 16px !important;
  color:#9E9E9E !important;
  background:rgba(255,255,255,1) !important;
  opacity:0.7 !important;
  border-radius: 0 !important;
}
.swiper-pagination-bullet-active {
  color:#fff !important;
  background: #FF6060 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue